import styled from 'styled-components'
import Background from '../../../images/background_login.png'
import { FlexContainer, Form } from '../../styled'

const FormContainer = styled(Form)`
	color: inherit;

	> button {
		&:hover {
			background: #7d3ce8;
		}
		color: #ffffff;
		font-weight: bold;
	}
`
const BackImage = styled(FlexContainer)`
	flex-basis: 100%;
	background-image: url(${Background});
	background-size: 65%;
	@media screen and (max-width: 1150px) {
		background-size: cover;
		background-position-y: -150px;
	}
	background-repeat: repeat-x;
	height: 100vh;
	background-color: #fff;
`

const Header = styled(FlexContainer)`
	width: 100%;
	height: fit-content;
	margin: 2% 10% 0;
	align-items: center;
	justify-content: space-between;
	ul {
		@media screen and (max-width: 768px) {
			display: none;
		}
		@media screen and (max-height: 575px) {
			display: none;
		}
		display: flex;
		li {
			list-style: none;
			a {
				text-decoration: none;
				svg {
					width: 1.5rem;
					height: 1.5rem;
				}
			}
		}
	}
	img {
		width: auto;
		height: 3rem;
		@media screen and (max-width: 768px) {
			display: none;
		}
		@media screen and (max-height: 575px) {
			display: none;
		}
	}
`
const Container = styled(FlexContainer)`
	justify-content: center;
	flex-flow: column;
	align-items: center;
	position: absolute;
	max-width: 90vw;
	max-height: 90vh;
	width: calc(16rem + 12vw);
	height: calc(24rem + 8vw);
	background-color: #ffffff;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);
	border-radius: 20px;
`
const LoginConfig = styled(FlexContainer)`
	width: 100%;
	margin-top: 1rem;
	justify-content: flex-end;
	font-size: 0.8rem;
	* {
		font-size: inherit !important;
	}
	.switch_container {
		margin: 0;
		padding: 6px 8px;
	}
	> button {
		color: #7d3ce8;
		background-color: transparent;
		margin-top: 0;
		border-radius: 0;
	}
`
const ContainerForm = styled(FlexContainer)`
	width: 100%;
	flex-flow: column;
	align-items: center;
	margin-top: 2rem;
	overflow: hidden;
	color: #989898;
`

const Setup2FaContainer = styled.div`
	display: flex;
	flex-direction: column;
`

const QrCodeContainer = styled.div`
	padding: 1rem;
	text-align: center;
`

export {
	BackImage,
	Container,
	ContainerForm,
	FormContainer,
	Header,
	LoginConfig,
	QrCodeContainer,
	Setup2FaContainer,
}
